import axios from 'axios';
import { IHttpService } from './IHttpService';

export class HttpService implements IHttpService {

  protected readonly apiKeys: any = {};

  constructor() {
  }

  get = async <TResult>(url: string, bearerToken?: string) => {
    const promise: Promise<TResult> = new Promise(async (resolve, reject) => {
      try {
        const response = await axios.get<TResult>(url, this.getConfig(false, bearerToken))
        resolve(response.data)
      } catch (error:any) {
        const status = Number(error?.response?.status ?? error?.status ?? 0);
        if (status == 401) {
          return reject({
            action: 'logout-login'
          })
        }
        reject(error)
      } finally {
      }
    });
    return promise;
  }

  post = async <TResult, TData>(url: string, data: TData, multipartFormData: boolean = false, bearerToken?: string) => {
    const promise: Promise<TResult> = new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post<TResult>(url, data, this.getConfig(multipartFormData, bearerToken))
        resolve(response.data)
      } catch (error: any) {
        const status = Number(error?.response?.status ?? error?.status ?? 0);
        if (status == 401) {
          return reject({
            action: 'logout-login'
          })
        }
        reject(error)
      } finally {
      }
    });
    return promise;
  }

  postToDownloadFile = <TData>(url: string, data: TData) => {
    return axios.request({
      url: url,
      method: 'POST',
      responseType: 'blob',
      headers: this.getConfig().headers,
      data: data
    });
  }

  put = async <TResult, TData>(url: string, data: TData) => {
    const promise: Promise<TResult> = new Promise(async (resolve, reject) => {
      try {
        const response = await axios.put<TResult>(url, data, this.getConfig())
        resolve(response.data)
      } catch (error:any) {
        const status = Number(error?.response?.status ?? error?.status ?? 0);
        if (status == 401) {
          return reject({
            action: 'logout-login'
          })
        }
        reject(error)
      } finally {
      }
    });
    return promise;
  }

  delete = async <TResult>(url: string) => {
    const promise: Promise<TResult> = new Promise(async (resolve, reject) => {
      try {
        const response = await axios.delete<TResult>(url, this.getConfig())
        resolve(response.data)
      } catch (error:any) {
        const status = Number(error?.response?.status ?? error?.status ?? 0);
        if (status == 401) {
          return reject({
            action: 'logout-login'
          })
        }
        reject(error)
      } finally {
      }
    });
    return promise;
  }

  private getConfig = (multipartFormData: boolean = false, bearerToken: string = '') => {
    const config: any = {
      headers: {
        "Content-Type": multipartFormData ? 'multipart/form-data' : 'application/json'
      }
    };
    if (bearerToken) {
      config.headers['Authorization'] = `Bearer ${bearerToken}`;
    }
    return config;
  }

  setApiKey = (name: string, key: string) => this.apiKeys[name] = key;
  getApiKey = (name: string) => this.apiKeys[name];
  logApiKeys = () => {
    console.log('ApiKeys:', this.apiKeys);
  }
}